import SentryGraphQLError from "@/helpers/exceptions/SentryGraphQLError";
import graphqlClient from "@/GQLClient";
import {
  type ResourceInput,
  SaveResourceDocument,
} from "@/graphql/generated-types";

const save = async (resource: ResourceInput) => {
  const response = await graphqlClient.mutate({
    mutation: SaveResourceDocument,
    variables: {
      resource,
    },
  });

  if (response.data?.resource?.save?.success) {
    return response.data.resource.save.id;
  }

  const error = new SentryGraphQLError("resource.save");
  const message = response.data?.resource?.save?.message;
  if (message) {
    error.message = `resource.save: ${message}`;
  }

  throw error;
};

export default {
  save,
};
